export default __webpack_public_path__ + "static/seal-68baf8c706d519bcc8e14d490ebff7d2.svg";